import { TrackerType } from '@vae/server/dist/client'

export const getColor = (trackerType: TrackerType) => {
	switch (trackerType) {
		case 'veryLow':
			return '#127d27'
		case 'veryHigh':
			return '#b21672'
		case 'low':
			return '#52ae32'
		case 'high':
			return '#ffc13e'
		default:
			return '#5C95FF'
	}
}
